import styled, { css } from "styled-components";
import { Tab } from "@renderbus/ui";
import { useGetTabsList } from "./hooks/useTableList";
import { CouponStatus, CouponType } from "./constant";
import {
  TabStoreContainerProvider,
  useTabStore,
} from "@/pages/coupon/store/tab-store";
import { RenderbusTabsProps } from "@renderbus/ui/components/tab";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import RechargeIcon from "@/assets/icons/coupon/recharge";
import { useNavigate } from "react-router-dom";
import { CouponRules } from "./components/coupon-rules";
import { RenderExchangeModal } from "./components/render-exchange-modal";

export function CouponView() {
  const { tabsList } = useGetTabsList();
  const {
    exchangeModal,
    setExchangeModal,
    setCurrentTab,
    activeKey,
    setActiveKey,
    setCurrentStatus,
    dealCouponsData,
    isMainUser,
    defaultAccount,
  } = useTabStore();
  const navigate = useNavigate();
  return (
    <CouponWrapper>
      <Tab
        tabsList={tabsList as unknown as RenderbusTabsProps["items"]}
        activeKey={activeKey}
        className="coupon-section-card"
        onChange={(key) => {
          setCurrentStatus(CouponStatus.All);
          setCurrentTab(Number(key) as CouponType);
          setActiveKey(key);
          navigate(`/coupon?activeName=${key}`);
        }}
        tabBarExtraContent={
          <RenderCouponExchange onClick={() => setExchangeModal(true)}>
            <RechargeIcon />
            <span>{getTranslateNsT("topup")("coupon-title")}</span>
          </RenderCouponExchange>
        }
      />
      <CouponRules />
      <RenderExchangeModal
        modalProps={{
          open: exchangeModal,
          onOk: () => {
            setCurrentStatus(CouponStatus.All);
            isMainUser ? dealCouponsData() : dealCouponsData(defaultAccount);
            setExchangeModal(false);
          },
          onCancel: () => {
            setExchangeModal(false);
          },
        }}
      />
    </CouponWrapper>
  );
}

export default function Coupon() {
  return (
    <TabStoreContainerProvider>
      <CouponView />
    </TabStoreContainerProvider>
  );
}

const CouponSectionCardCSS = css`
  border-radius: 4px;
  border: 1px solid #343538;
`;

const CouponWrapper = styled.div`
  display: flex;
  gap: 11px;
  height: calc(100% - 22px);
  .coupon-section-card {
    ${CouponSectionCardCSS};
  }
`;
const RenderCouponExchange = styled.div`
  color: #9ba2b0;
  font-size: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
  background: #3a3c41;
  border-radius: 4px;
  margin-right: 16px;
  padding: 4px 7px;
  span {
    padding-left: 4px;
  }
`;
